import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { IconField } from 'primeng/iconfield';
import { IftaLabelModule } from 'primeng/iftalabel';
import { InputIcon } from 'primeng/inputicon';
import { InputTextModule } from 'primeng/inputtext';
import { Select } from 'primeng/select';
import BodyType from '../../../../../../types/body-type/BodyType';
import Brand from '../../../../../../types/brand/Brand';
import CarClass from '../../../../../../types/car-class/CarClass';
import Media from '../../../../../../types/media/Media';
import VehicleModelWriteDTO from '../../../../../../types/vehicle-model/VehicleModelWriteDTO';
import { BodyTypeService } from '../../../../services/body-type.service';
import { BrandService } from '../../../../services/brand.service';
import { CarClassService } from '../../../../services/car-class.service';
import { MediaService } from '../../../../services/media.service';
import { VehicleModelService } from '../../../../services/vehicle-model.service';
import {
    SelectOrUploadMediaComponent
} from '../../media/select-or-upload-media-dialog/select-or-upload-media.component';

@Component({
    selector: 'app-update-vehicle-model-dialog',
    templateUrl: './update-vehicle-model-dialog.component.html',
    styleUrls: [ './update-vehicle-model-dialog.component.scss' ],
    imports: [
        DialogModule,
        InputTextModule,
        ButtonModule,
        FormsModule,
        IconField,
        InputIcon,
        Select,
        IftaLabelModule,
        SelectOrUploadMediaComponent,
    ]
})
export class UpdateVehicleModelDialogComponent implements OnInit, OnChanges {
    @Input() visible: boolean = false;
    @Input() vehicleModel: VehicleModelWriteDTO = new VehicleModelWriteDTO({});
    @Output() visibleChange: EventEmitter<boolean> = new EventEmitter<boolean>();
    @Output() vehicleModelUpdated: EventEmitter<any> = new EventEmitter<any>();

    public loading: boolean = false;

    public brands: Brand[] = [];
    public bodyTypes: BodyType[] = [];
    public carClasses: CarClass[] = [];
    public media: Media | undefined = undefined;

    constructor(
        private vehicleModelService: VehicleModelService,
        private brandService: BrandService,
        private bodyTypeService: BodyTypeService,
        private carClassService: CarClassService,
        private messageService: MessageService,
        private mediaService: MediaService
    ) {
    }

    public ngOnInit() {
        this.loadBrands();
        this.loadBodyTypes();
        this.loadCarClasses();
    }

    public ngOnChanges(changes: SimpleChanges): void {
        if (changes['visible'] && changes['visible'].currentValue === true) {
            if (this.vehicleModel?.imageId) {
                this.mediaService.getMedia(this.vehicleModel.imageId).then((media) => {
                    this.media = media;
                }).catch((error) => {
                    this.messageService.add({
                        severity: 'error',
                        summary: 'Error',
                        detail: error.message,
                        life: 3000,
                    });
                });
            } else {
                this.media = undefined;
            }
        }
    }

    private loadBrands() {
        this.brandService.getAllBrands().then((brands) => {
            this.brands = brands;
        }).catch((error: any) => {
            this.messageService.add({
                severity: 'error',
                summary: 'Error',
                detail: error.message,
                life: 3000,
            });
        });
    }

    private loadBodyTypes() {
        this.bodyTypeService.getAllBodyTypes().then((bodyTypes) => {
            this.bodyTypes = bodyTypes;
        }).catch((error: any) => {
            this.messageService.add({
                severity: 'error',
                summary: 'Error',
                detail: error.message,
                life: 3000,
            });
        });
    }

    private loadCarClasses() {
        this.carClassService.getAllCarClasses().then((carClasses) => {
            this.carClasses = carClasses;
        }).catch((error: any) => {
            this.messageService.add({
                severity: 'error',
                summary: 'Error',
                detail: error.message,
                life: 3000,
            });
        });
    }

    close(): void {
        this.visible = false;
        this.visibleChange.emit(this.visible);
    }

    updateVehicleModel(): void {
        this.loading = true;

        if (this.media) {
            this.vehicleModel.imageId = this.media.id;
        } else {
            this.vehicleModel.imageId = undefined;
        }

        this.vehicleModelService
            .updateVehicleModel(this.vehicleModel)
            .then(() => {
                this.messageService.add({
                    severity: 'success',
                    summary: 'Success',
                    detail: 'Vehicle model updated',
                    life: 3000,
                });
                this.vehicleModelUpdated.emit();
                this.close();
            })
            .catch((error: any) => {
                console.error('Failed to update vehicle model:', error);
                this.messageService.add({
                    severity: 'error',
                    summary: 'Error',
                    detail: error.message,
                    life: 3000,
                });
            })
            .finally(() => {
                this.loading = false;
            });
    }
}
